import React, { FC } from 'react';
import router from './routes';
import { HelmetProvider } from 'react-helmet-async';
import MantineTheme from '@styles/mantine';
import SentryProvider from '@shared/modules/sentry/components/SentryProvider';
import { NavigationProgress } from '@mantine/nprogress';
import { RouterProvider } from 'react-router-dom';
import ApiDownIndicator from '@core/http/components/ApiDownIndicator';
import { Group, Loader } from '@mantine/core';

const App: FC = () => {
  return (
    <SentryProvider>
      <MantineTheme>
        <ApiDownIndicator />

        <NavigationProgress color="blue" size={2} />

        <HelmetProvider>
          <RouterProvider
            router={router}
            fallbackElement={
              <Group justify="center" h="100vh">
                <Loader size="lg" type="bars" />
              </Group>
            }
          />
        </HelmetProvider>
      </MantineTheme>
    </SentryProvider>
  );
};

export default App;
